import * as _ from "lodash";
import * as angular from "angular";
import { TalkingPoint } from "../../models/talking-point.model";
import { TeamDataProvider } from "../../data-provider/team.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { TalkingPointDataProvider } from "../../data-provider/talking-point.dp";

let CreateTalkingPointComponent = {
    selector: "vcCreateTalkingPoint",
    templateUrl:
        "/angular/components/talking-point/create-talking-point.component.html",
    bindings: {
        onlyTeam: "=",
        selectedPoint: "=",
        selectedCategory: "=",
    },
    controller: class CreateTalkingPointController {
        // * bindings for typescript compiler *
        public onlyTeam: any;
        public selectedPoint: any;
        public selectedCategory: any;
        // ************************************

        public dialog: DialogUtils;
        public dataProvider: TalkingPointDataProvider;
        public teamDataProvider: TeamDataProvider;
        public __app_type: string;
        public isOrganisationType;
        public $scope;
        public point;
        public categories;
        public categorySearch = "";
        public suggestions = [
            { tpcname: "Introduction" },
            { tpcname: "Interaction Script" },
            { tpcname: "Our Policies" },
            { tpcname: "General Instructions" },
            { tpcname: "Background Info" },
            { tpcname: "Contact Info" },
            { tpcname: "Social Media Messaging" },
            { tpcname: "FAQ" },
        ];

        constructor(
            $scope: any,
            __app_type: string,
            DialogUtils: DialogUtils,
            TeamDataProvider: TeamDataProvider,
            TalkingPointDataProvider: TalkingPointDataProvider
        ) {
            this.dialog = DialogUtils;
            this.dataProvider = TalkingPointDataProvider;
            this.teamDataProvider = TeamDataProvider;
            this.__app_type = __app_type;
            this.isOrganisationType = __app_type == "LEADER";
            this.$scope = $scope;

            this.dataProvider.getCategories().then((categories) => {
                let filterSuggestions = this.suggestions.filter((item) => {
                    for (const cat of categories) {
                        if (item.tpcname == cat.tpcname) {
                            return false;
                        }
                    }
                    return true;
                });
                this.categories = [...categories, ...filterSuggestions];
            });
        }

        $onInit() {
            if (this.selectedPoint) {
                this.point = new TalkingPoint(this.selectedPoint);
                this.point.category = _.cloneDeep(this.selectedCategory);
                this.point.category.points = null;
                this.point.category.filteredPoints = null;
            } else {
                this.point = new TalkingPoint();
            }
        }

        cancel() {
            this.dialog.cancel();
        }

        filterCategories(query) {
            return query && query != ""
                ? this.categories.filter((obj) => {
                      return (
                          obj["tpcname"]
                              .toLowerCase()
                              .indexOf(query.toLowerCase()) != -1
                      );
                  })
                : this.categories;
        }

        savePoint(point) {
            if (
                !point.category ||
                this.categorySearch != point.category.tpcname
            ) {
                point.category = { tpcname: this.categorySearch };
            }
            this.dialog.hide(point);
        }
    },
};

angular
    .module("talkingPoint", [])
    .component(
        CreateTalkingPointComponent.selector,
        CreateTalkingPointComponent
    );
